import * as SelectPrimitive from "@radix-ui/react-select";

const SelectGroup = SelectPrimitive.Group;

export { SelectGroup };
